/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatSystemMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatSystemMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_SYSTEM);
};
$hxClasses['com.inq.flash.client.control.messagehandlers.ChatSystemMessageHandler'] = com.inq.flash.client.control.messagehandlers.ChatSystemMessageHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.ChatSystemMessageHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","ChatSystemMessageHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.ChatSystemMessageHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.ChatSystemMessageHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ChatSystemMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatSystemMessageHandler.prototype.processMessage = function(message) {
	var textToDisplay = message.getProperty("client.display.text");
	if(textToDisplay != null) {
		var displayText = StringTools.trim(textToDisplay);
		com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow("",
			displayText,
			com.inq.flash.client.chatskins.ChatTextArea.SYSTEM,
			-1, null, message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY));
	} else {
		var chatText = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA);
		com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow("bob",chatText,com.inq.flash.client.chatskins.ChatTextArea.SYSTEM,-1, null, message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY));
	}
};

/** @type {com.inq.flash.client.control.messagehandlers.ChatSystemMessageHandler} */
com.inq.flash.client.control.messagehandlers.ChatSystemMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ChatSystemMessageHandler;
